import { useTranslation } from 'react-i18next'
import { Button, Input, Modal, message } from 'antd'
import { useRecoilState, useRecoilValue } from 'recoil'
import { showEmailLinkDisabledModalState, temporaryPasswordState } from '../recoil/atoms'
import { useHistory } from 'react-router-dom'
import { CopyOutlined } from '@ant-design/icons'

const EmailLinkDisabledModal = () => {
  const { t } = useTranslation('emailLinkDisabled')
  const history = useHistory()

  const [showModal, setShowModal] = useRecoilState(showEmailLinkDisabledModalState)
  const temporaryPassword = useRecoilValue(temporaryPasswordState)

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(temporaryPassword)
      .then(() => {
        message.success(t('copiedSuccess'))
      })
      .catch((error) => {
        console.error('Failed to copy password:', error)
        message.error('Failed to copy password')
      })
  }

  const handleContinue = () => {
    setShowModal(false)
    history.push('/profile/password')
  }

  return (
    <Modal
      title={t('title')}
      open={showModal}
      onCancel={handleContinue}
      maskClosable={false}
      closable={false}
      width={600}
      footer={[
        <Button key="continue" type="primary" size="large" onClick={handleContinue}>
          {t('continueButton')}
        </Button>,
      ]}
    >
      <div className="space-y-4">
        <div>
          <p className="text-base mb-4">{t('message')}</p>
          <p className="text-base font-semibold mb-2">{t('passwordGenerated')}</p>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">{t('passwordLabel')}</label>
          <div className="flex gap-2">
            <Input
              value={temporaryPassword}
              readOnly
              size="large"
              className="font-mono text-lg"
              style={{ fontFamily: 'monospace' }}
            />
            <Button
              icon={<CopyOutlined />}
              size="large"
              onClick={handleCopyToClipboard}
              title={t('copyButton')}
            >
              {t('copyButton')}
            </Button>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded p-4 mt-4">
          <p className="text-sm">{t('instructions')}</p>
          <p className="text-sm mt-2">{t('instructionsSecondary')}</p>
        </div>
      </div>
    </Modal>
  )
}

export default EmailLinkDisabledModal
